import { useDispatch, useSelector } from "react-redux";
import { RootState } from "../../../app/store";
import { Button, Col, Form, Row, Table } from "react-bootstrap";
import { Link } from "react-router-dom";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faPlus, faTrash } from "@fortawesome/free-solid-svg-icons";
import { useState } from "react";
import { removeCiot, addCiot } from "../../../features/manifestoSlice";
import { CiotInterface, SelectObjectRemoveInterface } from "../../../interfaces";
import { getUuidV4, validarCPFCNPJ } from "../../../utils/utils";
import { JConfirmDelete, MensagemModal } from "../../../components/Components";

const initialForm: CiotInterface = {
    id: 0,
    ciot: '',
    cpfcnpj: ''
}

const initialSelect: SelectObjectRemoveInterface = {
    id: 0,
    title: ''
}

export default function Ciot() {
    const dispatch = useDispatch();
    const listaCiots = useSelector((state: RootState) => state.manifesto.manifesto.modal_rodoviario?.infANTT.infCIOT);
    const [form, setForm] = useState(initialForm)
    const [showAlert, setShowAlert] = useState<boolean>(false);
    const [messageAlert, setMessageAlert] = useState('');
    const [selected, setSelected] = useState<SelectObjectRemoveInterface>(initialSelect);
    const [showModal, setShowModal] = useState<boolean>(false);

    const alerta = (message: string) => {
        setMessageAlert(message);
        setShowAlert(true)
    }

    const handleCloseModal = () => {
        setShowModal(false);
        setSelected(initialSelect);
    }

    const handleOpenModal = (value: SelectObjectRemoveInterface) => {
        setSelected(value);
        setShowModal(true);
    }

    const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
        const { name, value } = e.target;

        setForm((prev) => ({
            ...prev,
            [name]: value.trim()
        }))
    }

    const validarPreenchimento = () => {

        if (form.ciot === "") {
            alerta("Informe o número do CIOT.");
            return false;
        }

        if (form.cpfcnpj === "") {
            alerta('Informe o CPF/CNPJ.');
            return false;
        }

        if (!validarCPFCNPJ(form.cpfcnpj)) {
            alerta('CPF/CNPJ inválido.');
            return false;
        }

        if (listaCiots.find((item: CiotInterface) => item.ciot === form.ciot && item.cpfcnpj === form.cpfcnpj)) {
            alerta('Número do CIOT já foi adicionado para CPF/CNPJ informado.');
            return false;
        }

        return true;
    }

    const handleAdd = () => {

        if (validarPreenchimento()) {
            dispatch(addCiot({
                ...form,
                id: getUuidV4()
            }));
            setForm(initialForm);
        }

    }

    const handleRemover = (id: number | string) => {
        dispatch(removeCiot(id));
        setForm(initialForm);
        setShowModal(false);
        setSelected(initialSelect);
    }

    return (<>
        <Row className="mb-3 g-2">
            <Col md={'auto'} className="">
                <Form.Group >
                    <Form.Label>Número Ciot</Form.Label>
                    <Form.Control name="ciot"
                        maxLength={12} type="text" onChange={handleChange} value={form.ciot} />
                </Form.Group>
            </Col>

            <Col md={'auto'}>
                <Form.Group  >
                    <Form.Label>CPF/CNPJ</Form.Label>
                    <Form.Control name="cpfcnpj" value={form.cpfcnpj}
                        maxLength={14} type="text" onChange={handleChange} />
                </Form.Group>
            </Col>

            <Col md={'auto'} className="d-flex align-items-end">
                <Form.Group >
                    <Button variant="primary" onClick={handleAdd}>
                        <FontAwesomeIcon icon={faPlus} />  Adicionar
                    </Button>
                </Form.Group>
            </Col>
        </Row>

        <Table striped bordered hover size="sm">
            <thead className="table-light">
                <tr>
                    <th className="text-center" style={{ width: '2.5rem' }}>#</th>
                    <th>Número CIOT</th>
                    <th>CPF/CNPJ</th>
                </tr>
            </thead>

            <tbody>
                {listaCiots?.map((item: CiotInterface) => (
                    <tr key={item.id}>
                        <td className="text-center">
                            <Link to={''} className="text-danger"
                                onClick={() => handleOpenModal({ id: item.id, title: item.ciot })}>
                                <FontAwesomeIcon icon={faTrash} />
                            </Link>
                        </td>
                        <td>{item.ciot}</td>
                        <td>{item.cpfcnpj}</td>
                    </tr>
                ))}
            </tbody>
        </Table>

        <JConfirmDelete
            showModal={showModal}
            handleCloseModal={handleCloseModal}
            handleDelete={handleRemover}
            selectedObject={selected.title}
            id={selected.id}
        />

        <MensagemModal
            show={showAlert}
            handleClose={() => setShowAlert(false)}
            mensagem={messageAlert}
        />
    </>)
}
